import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Row, Container } from "react-bootstrap";
import "./styles.scss";
import { RequiredFields } from "../Icon";

export const Legend = ({
  icon,
  defaultIconColor,
  classes,
  leftMessage,
  rightMessage,
}) => (
  <Container className={classNames("mydpd-legend", classes.container)}>
    <Row noGutters className={classNames("mydpd-legend-body", classes.body)}>
      <div
        className={classNames(
          "d-flex mydpd-legend-left-content",
          classes.leftContent
        )}
      >
        {!!leftMessage && (
          <>
            <div
              className={classNames(
                "d-flex align-items-center",
                classes.iconContainer
              )}
            >
              {icon ? (
                <img className={classes.icon} alt="" src={icon} />
              ) : (
                <RequiredFields color={defaultIconColor} />
              )}
            </div>
            <div
              className={classNames(
                "d-flex align-items-center",
                classes.message
              )}
            >
              <span
                className={classNames(
                  "mydpd-legend-message-text",
                  classes.messageText
                )}
              >
                {leftMessage}
              </span>
            </div>
          </>
        )}
      </div>
      {!!rightMessage && (
        <div
          className={classNames(
            "d-flex mydpd-legend-right-content",
            classes.rightContent
          )}
        >
          <div
            className={classNames("d-flex align-items-center", classes.message)}
          >
            <span
              className={classNames(
                "mydpd-legend-message-text",
                classes.messageText
              )}
            >
              {rightMessage}
            </span>
          </div>
        </div>
      )}
    </Row>
  </Container>
);

Legend.defaultProps = {
  classes: {
    container: "",
    body: "",
    iconContainer: "",
    icon: "",
    message: "",
    messageText: "",
  },
};

Legend.propTypes = {
  defaultIconColor: PropTypes.string,
  icon: PropTypes.string,
  classes: PropTypes.object,
  leftMessage: PropTypes.string,
  rightMessage: PropTypes.string,
};
